<template>
  <div :class="['alert', {'-visible': alertIsVisible}]">
    {{ alertMessage }}
  </div>
</template>

<script>

import { mapGetters } from 'vuex';

export default {
  name: 'Alert',
  props: {
    type: String,
    message: String,
  },
  computed: mapGetters({
    alertIsVisible: 'application/alertIsVisible',
    alertMessage: 'application/alertMessage',
  }),
};

</script>



// WEBPACK FOOTER //
// src/components/Alert.vue